import { createContext } from 'react';
import type { ApplicationModuleKey, EnabledModulesState } from '@/types/applicationModule';

export interface EnabledModulesContextValue {
  enabledModules: EnabledModulesState;
  toggleModule: (moduleKey: ApplicationModuleKey) => void;
}

export const EnabledModulesContext = createContext<EnabledModulesContextValue | null>(null);
